import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import useSiteConfig from "@/hooks/useSiteConfig";

export default function WhatsAppButton() {
  const { config } = useSiteConfig();
  const [chatOpen, setChatOpen] = useState(false);

  // Listen for chat-widget state changes so we can hide cleanly when the
  // chat panel is open (avoids the WhatsApp/Close/Chat-FAB stack collision).
  useEffect(() => {
    const onChange = (e) => setChatOpen(!!e?.detail?.open);
    window.addEventListener("quasar:chat-state", onChange);
    return () => window.removeEventListener("quasar:chat-state", onChange);
  }, []);

  const num = (config?.whatsapp?.number || "").replace(/\D/g, "");
  if (!num) return null;
  const msg = encodeURIComponent(config?.whatsapp?.message || "Hi Quantum Star — I'd like to know more.");
  const href = `https://wa.me/${num}?text=${msg}`;

  return (
    <AnimatePresence>
      {!chatOpen && (
        <motion.a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float"
          aria-label="Chat with us on WhatsApp"
          initial={{ opacity: 0, y: 20, scale: 0.6 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 12, scale: 0.6 }}
          transition={{ delay: 0, duration: 0.25 }}
          className="fixed z-[60] bottom-[10.5rem] right-6 sm:bottom-6 sm:right-[180px] inline-flex items-center justify-center h-12 w-12 rounded-full bg-[#25D366] text-white shadow-[0_0_36px_-6px_rgba(37,211,102,0.6)] hover:scale-[1.06] active:scale-95 transition-transform"
        >
          <MessageCircle size={20} fill="white" strokeWidth={0} />
          <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-emerald-400 ring-2 ring-[#070709] pulse-dot" />
        </motion.a>
      )}
    </AnimatePresence>
  );
}
